import { StyleSheet, Text, View } from "react-native";
import React from "react";

const LotteryGiftIcon = ({ iconName, style }) => {
  return (
    <View style={[styles.container, style]}>
      <Text style={styles.text}>{iconName}</Text>
    </View>
  );
};

export default LotteryGiftIcon;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    width: 125,
    height: 125,
    padding: 5,
    backgroundColor: "#7A7A7AFA",
  },
  text: {
    color: "#000000",
    fontSize: 40,
  },
});
